import { render, staticRenderFns } from "./PropostaTerapeuticaListComponent.vue?vue&type=template&id=d1a1bd16"
import script from "./PropostaTerapeuticaListComponent.vue?vue&type=script&lang=js"
export * from "./PropostaTerapeuticaListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports